module.exports = __webpack_public_path__ + "static/media/move_from_shooting_to_shooting_1.e7962620.mp3";